import { BarChart } from "@mantine/charts";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import { ColorSwatch, Group, Paper, Text } from "@mantine/core";
import LoaderStats from "../../LoaderStats";
import { useLanguage } from "../../../../../stores/LanguageStore";

const ActivitySummary = () => {
  const lang = useLanguage((s) => s.language);
  const statisticsDate = useReportingStore((s) => s.actualStatsDate);
  const dateRange = useReportingStore((s) => s.dateRange);

  return (
    <Paper pos={"relative"} w={"100%"} p={"xl"} pt={"md"}>
      <LoaderStats isDate />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.sending_volume}{" "}
          {!dateRange.end_date && !dateRange.start_date
            ? lang.reports.last_60_days
            : lang.reports.per_date}
        </Text>
      </Group>

      <BarChart
        h={300}
        w={"100%"}
        data={statisticsDate}
        dataKey="date"
        type="stacked"
        series={[
          { name: "email_sent", label: "Emails", color: "secondary.6" },
          { name: "linkedin_sent", label: "LinkedIn", color: "blue.6" },
          { name: "sms_sent", label: "SMS", color: "green.6" },
        ]}
        tickLine="y"
        yAxisLabel="Volume"
        xAxisLabel="Date"
        barProps={(props) => {
          return {
            isAnimationActive: true,
            animationDuration: 600,
            radius: props.name === "linkedin_sent" ? [8, 8, 0, 0] : 0,
          };
        }}
      />

      <Group gap={"xl"} justify="center" align="center" mt={16}>
        <Group>
          <ColorSwatch color={`var(--mantine-color-secondary-5)`} size={16} />
          <Text size="sm">{lang.reports.emails_sent}</Text>
        </Group>
        <Group>
          <ColorSwatch color={`var(--mantine-color-blue-5)`} size={16} />
          <Text size="sm">{lang.reports.linkedin_actions}</Text>
        </Group>
      </Group>
    </Paper>
  );
};

export default ActivitySummary;
